import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const lastLogin = (data) => {
  return apiRequestType(apiTypes.GET, apiConstants.LASTLOGIN.LAST_LOGIN_TIME,data);
};

export default lastLogin;
